const GTM_SRC_DATA_ATTRIBUTE = 'data-gtm-server-url';
const GTM_CONTAINER_ID_COOKIE = 'gtmId'

const getGTMId = () => {
  const gtmId = CoreJS.CookieHelper.getCookieValue(GTM_CONTAINER_ID_COOKIE);

  if (!gtmId) {
    throw new Error('## GTM - Could not fetch gtmId from cookie');
  }

  return gtmId;
};

const getGTMUrl = () => {
  const gtmUrlElement = document.querySelector(`[${GTM_SRC_DATA_ATTRIBUTE}]`);

  if (!gtmUrlElement) {
    throw new Error(`## GTM - Could not find any ${GTM_SRC_DATA_ATTRIBUTE}`);
  }

  return (gtmUrlElement as HTMLElement).getAttribute(GTM_SRC_DATA_ATTRIBUTE);
};

export const GTM_SCRIPT_ID = 'gtm-script';

export const createGTMScriptTag = () => {
  const scriptTag = document.createElement('script');
  const gtmUrl = getGTMUrl();
  const gtmId = getGTMId();

  scriptTag.type = 'text/javascript';
  scriptTag.id = GTM_SCRIPT_ID;
  scriptTag.src = `${gtmUrl}${gtmId}`;
  scriptTag.async = true;

  return scriptTag;
};
